import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { IKitGetReq, TKitGetRep } from '../../lib-shared/api/Kit.Type';
import {
  IPickupGetIdReq,
  IPickupGetPickupIdReq, IPickupGetReq, IPickupGetStockReq, IPickupPostIdReq, IPickupPutIdReq,
  TPickupGetIdRep,
  TPickupGetPickupIdRep, TPickupGetRep, TPickupGetStockRep, TPickupPostIdRep, TPickupPutIdRep,
} from '../../lib-shared/api/Pickup.Type';
import {
  IUserPostChangeForgottenPasswordReq,
  TUserPostChangeForgottenPasswordRep
} from '../../lib-shared/api/User.Type';
import { IOrderGetKitBatchReq, TOrderGetKitBatchRep } from '../../lib-shared/api/Order.Type';

@Injectable({
  providedIn: 'root'
})
export class ApiPublicService {
  private url = ApiPublicService.generateUrl(environment.api_url);

  constructor(
    private http: HttpClient
  ) {
  }

  static generateUrl(base: string) {
    return `${base}`;
  }

  setUrl(base: string) {
    this.url = ApiPublicService.generateUrl(base);
  }

  get() {
    return this.http.get(`${this.url}`);
  }

  getDeadlineList() {
    return this.http.get(`${this.url}/deadline`);
  }

  getKit(params: IKitGetReq) {
    return this.http.get<TKitGetRep>(`${this.url}/kit`);
  }

  postOrderKitBatch(params: { pickupId: string, kitList: { kitId: number, quantity: number }[] }) {
    return this.http.post(`${this.url}/order/kitbatch`, params);
  }

  getOrderKitBatch(params: IOrderGetKitBatchReq) {
    return this.http.get<TOrderGetKitBatchRep>(`${this.url}/order/kitbatch`, {
      // as any is here for retro compatibility with old version of angular
      params: new HttpParams({fromObject: params as any}),
    });
  }

  postPickup(params: IPickupPostIdReq) {
    return this.http.post<TPickupPostIdRep>(`${this.url}/pickup`, params);
  }

  putPickupId(id: string, params: IPickupPutIdReq) {
    return this.http.put<TPickupPutIdRep>(`${this.url}/pickup/${id}`, params);
  }

  getPickupPickupId(id: string, params: IPickupGetPickupIdReq) {
    return this.http.get<TPickupGetPickupIdRep>(`${this.url}/pickup/pickup/${id}`);
  }

  getPickupStock(params: IPickupGetStockReq) {
    const {kitList, ...address} = params;
    // as any is here for retro compatibility with old version of angular
    let httpParams = new HttpParams({fromObject: address as any});
    (kitList || []).forEach(k => {
      httpParams = httpParams.append('kitListKitId[]', k.kitId.toString());
      httpParams = httpParams.append('kitListQuantity[]', k.quantity.toString());
    });

    return this.http.get<TPickupGetStockRep>(`${this.url}/pickup/stock`, {
      params: httpParams,
    });
  }

  getPickupId(id: string, params: IPickupGetIdReq) {
    return this.http.get<TPickupGetIdRep>(`${this.url}/pickup/${id}`);
  }

  getPickup(params: IPickupGetReq) {
    return this.http.get<TPickupGetRep>(`${this.url}/pickup`, {
      // as any is here for retro compatibility with old version of angular
      params: new HttpParams({fromObject: params as any}),
    });
  }

  postUserChangeForgottenPassword(params: IUserPostChangeForgottenPasswordReq) {
    return this.http.post<TUserPostChangeForgottenPasswordRep>(`${this.url}/user/changeforgottenpassword`, params);
  }

  postUserForgottenPassword(data: { email: string }) {
    return this.http.post(`${this.url}/user/forgottenpassword`, data);
  }
}
